import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const routeLoading = ref(false)
  const routeLoadingMessage = ref('Loading')

  function startRouteLoading(message = 'Loading') {
    routeLoading.value = true
    routeLoadingMessage.value = message
  }

  function stopRouteLoading() {
    routeLoading.value = false
  }

  return {
    routeLoading,
    routeLoadingMessage,
    startRouteLoading,
    stopRouteLoading,
  }
})
